import React from "react";
import {
  ACol,
  AContainer,
  APanel,
  APanelBody,
  APanelHeader,
  APanelTitle,
  ARow
} from "@cisco-sbg-ui/magna-react";
import Playbook from "features/incidentDetail/response/Playbook";

const IncidentDetailResponse = () => {
  return (
    <AContainer
      fluid
      className="pa-0"
      data-testid="IncidentDetailResponse-Container">
      <ARow noGutters>
        <ACol md="12" lg="9">
          <Playbook />
        </ACol>
        <ACol md="12" lg="3">
          <APanel className="mr-0">
            <APanelHeader>
              <APanelTitle>Actions taken</APanelTitle>
            </APanelHeader>
            <APanelBody>log goes here</APanelBody>
          </APanel>
        </ACol>
      </ARow>
    </AContainer>
  );
};

export default IncidentDetailResponse;
